<template>
  <div class="cpunk_page page_detail_prev">
    <div class="tip">
      <img src="~@static/funding_cpunk/creation/preview_t1.png" alt="" />
    </div>
    <!-- one -->
    <div class="part_tit one">
      <img src="~@static/funding_cpunk/creation/preview_title1.png" alt="" />
      <div class="edit" @click="edit" data-part="1"></div>
    </div>
    <div class="cp_list1">
      <div class="field">
        <img src="~@static/funding_cpunk/project_item_1a.png" class="cover1" alt="" />
        <img :src="hostUrl + projectCreateData.cover" alt="" class="img" />
        <img src="~@static/funding_cpunk/project_item_1b.png" class="cover2" alt="" />
        <div class="theme">精选派对</div>
        <div class="t">
          <p class="t1">{{ projectCreateData.title }}</p>
          <p class="t2">{{ projectCreateData.summary }}</p>
          <div class="t3">
            <div class="t3_1">
              <img class="icon" src="~@static/fundingnew/profile/icon-location.png" />
              <div class="text">{{ projectCreateData.city }}</div>
            </div>
            <div class="t3_2">
              <img class="icon" src="~@static/fundingnew/profile/icon-like.png" />
              <div class="text">150</div>
            </div>
          </div>
        </div>
      </div>
      <div class="tags-list1 clearfix">
        <div class="item-box" v-for="(item, index) of projectCreateData.tagsName" :key="index"># {{ item }}</div>
      </div>
    </div>

    <!-- two -->
    <div class="part_tit two">
      <img src="~@static/funding_cpunk/creation/preview_title2.png" alt="" />
      <div class="edit" @click="edit" data-part="2"></div>
    </div>
    <!-- 轮播图 -->
    <div class="banner-wrapper">
      <swiper class="banner-list" :options="swiperOption" v-if="projectCreateData.picture">
        <swiper-slide class="banner-item" v-for="(item, index) in projectCreateData.picture" :key="index">
          <div class="banner-item-img" :style="{ backgroundImage: 'url(' + hostUrl + item + ')' }"></div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <img src="~@static/funding_cpunk/creation/pic_border.png" class="cover" alt="" />
    </div>
    <!-- basic -->
    <div class="project-basic">
      <h1 class="project-title">{{ projectCreateData.title }}</h1>
      <h2 class="project-sub-title">{{ projectCreateData.summary }}</h2>
      <!--  -->
      <div class="project-city"><img src="~@static/funding/icon-pin.png" class="icon" />{{ projectCreateData.province }} {{ projectCreateData.city }}</div>
      <div class="project-author"><img src="~@static/funding/icon-author.png" class="icon" />by {{ projectCreateData.userName }}</div>
      <ul class="project-tags-list">
        <li class="tag-item" v-for="item of projectCreateData.tagsName" :key="item.id">#{{ item }}</li>
      </ul>
    </div>
    <!--  -->
    <div class="project-desc show">
      <div class="t" v-html="projectCreateData.description"></div>
    </div>
    <!-- 视频 -->
    <div class="video-preview">
      <div class="video-cover" v-if="previewVideoUrl" @click="playVideo">
        <iframe frameborder="0" width="100%" height="100%" :src="previewVideoUrl" allowfullscreen></iframe>
      </div>
    </div>

    <div class="project-input-cell links" v-if="projectCreateData.links && projectCreateData.links.length">
      <div class="item" v-for="(item, index) in projectCreateData.links" :key="index" @click="bindToLink(item.url)">
        <div class="icon">
          <img src="~@static/funding_cpunk/creation/icon-link.png" alt="" />
        </div>
        <div class="bar gradient-bg">{{ item.desc }}</div>
      </div>
    </div>

    <div class="project-input-cell people">
      <div class="item">
        <div class="icon">
          <img src="~@static/funding_cpunk/creation/icon-people.png" alt="" />
        </div>
        <div class="bar gradient-bg">
          <span>夜计划规模</span>
          <span>{{ projectCreateData.num }}人</span>
        </div>
      </div>
    </div>

    <!-- three -->
    <div class="part_tit three">
      <img src="~@static/funding_cpunk/creation/preview_title3.png" alt="" />
      <div class="edit" @click="edit" data-part="3"></div>
    </div>
    <div class="user-info">
      <div class="project-username">
        <span>联系人</span><span class="u-name">{{ projectCreateData.name }}</span>
      </div>
      <div class="project-userphone">
        <span>手机号码</span><span class="u-phone">{{ projectCreateData.telephone }}</span>
      </div>
    </div>
    <div class="protocol-label">
      <div class="checkbox" :class="{ active: isProtocolAccepted }" @click="bindProtocolToggle"></div>
      <div class="text">
        我已阅读并同意<span class="link" @click="bindToRegulation">使用条款</span>和<span class="link" @click="bindToProtocol">隐私条款</span>
      </div>
    </div>
    <div class="create_btn_s1" @click="bindCreateSubmit"># 完成 #</div>
    <div style="height: 60px"></div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import StepBtn from '../components/StepBtn'
import { behavior } from '@/utils/behavior'

export default {
  name: '',
  components: {
    StepBtn,
  },
  data() {
    return {
      bgImg: require('@static/fundingnew/creation/step3/textarea-bg.png'),
      hostUrl: this.$apiConfig.host,
      uploadUrl: this.$apiConfig.uploadUrl,
      projectCreateData: {},
      previewVideoUrl: '',
      canSubmit: true,
      voicePlaying: false,
      isProtocolAccepted: false,
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
        },
        //循环
        loop: true,
        initialSlide: 0,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        //自动播放
        autoplay: {
          delay: 22500,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        //滑动速度
        speed: 500,
        //滑动方向
        direction: 'horizontal',
        on: {
          slideChangeTransitionEnd: function () {
            // vm.swiperCurrent = this.realIndex //loop模式下真实索引
          },
        },
        preventLinksPropagation: false,
      },
      isBili: false,
    }
  },
  computed: {
    ...mapState(['fundingNewProjectCreate', 'authorization']),
  },
  created() {
    let { creation_from } = this.$route.query
    if (creation_from === 'bili') {
      this.isBili = true
    }
  },
  mounted() {
    console.log('this.fundingNewProjectCreate"', this.fundingNewProjectCreate)
    this.projectCreateData = this.fundingNewProjectCreate
    this.getVideoVid()
  },
  methods: {
    ...mapMutations(['setFundingNewProjectCreate']),
    openLink(url) {
      if (url) {
        window.location.href = url
      }
    },
    getVideoVid() {
      let _url = this.projectCreateData && this.projectCreateData.video && this.projectCreateData.video.url
      if (_url) {
        let vid = ''
        if (_url.includes('b23.tv')) {
          this.$request.post(this.$apiConfig.videoUrl, { url: _url }).then(res => {
            let resData = res.data
            if (resData.code == 0) {
              let u = resData.data.redirect_url
              let i0 = u.indexOf('?')
              if (i0 != -1) {
                u = u.slice(0, i0)
              }
              let u1 = u.split('/')
              vid = u1[u1.length - 1]
              this.previewVideoUrl = `https://player.bilibili.com/player.html?bvid=${vid}&page=1`
              _jcq.push(['_track', 'video_preview'])
              return
            }
          })
        }

        if (_url.includes('bilibili')) {
          if (_url.match(/\/$/) != null) {
            _url = _url.slice(0, -1)
          }
          _url = _url.split('/')
          vid = _url[_url.length - 1]
          this.previewVideoUrl = `https://player.bilibili.com/player.html?bvid=${vid}&page=1`
        } else {
          _url = _url.split('/')
          vid = _url[_url.length - 1].split('.')[0]
          this.previewVideoUrl = `https://v.qq.com/txp/iframe/player.html?vid=${vid}&tiny=0&auto=0`
        }
        _jcq.push(['_track', 'video_preview'])
      }
    },
    bindProtocolToggle: function () {
      this.isProtocolAccepted = !this.isProtocolAccepted
      _jcq.push(['_track', 'yjhbcagree'])
      behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc35' })
    },
    bindToProtocol() {
      this.$router.push('/protocol')
      _jcq.push(['_track', 'yjhbctc'])
      behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc36' })
    },
    bindToRegulation() {
      this.$router.push('/regulation')
      _jcq.push(['_track', 'yjhbcprivacy_policy'])
      behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc37' })
    },
    edit(e) {
      let { part } = e.currentTarget.dataset
      this.$router.replace({ path: `/fundingnew/creation/step${part}?path_from=preview`, query: this.$route.query })
      if (part == 1) {
        _jcq.push(['_track', 'yjhbccover_edit'])
        behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc32' })
      } else if (part == 2) {
        _jcq.push(['_track', 'yjhbcinfo_edit'])
        behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc33' })
      } else if (part == 3) {
        _jcq.push(['_track', 'yjhbcmessage_edit'])
        behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc34' })
      }
    },
    bindCreateSubmit() {
      if (!this.canSubmit) return
      if (!this.isProtocolAccepted) {
        alert('请阅读并同意使用条款和隐私条款')
        return false
      }
      this.canSubmit = false

      let { name, telephone, title, summary, tags, province, city, description, description_link, picture, video, links, theme, num } = this.projectCreateData

      let postData = {
        name: name,
        telephone: telephone,
        title: title,
        summary: summary,
        province: province,
        city: city,
        description: description,
        description_link: description_link,
        theme: theme.value,
        number: num,
        support: '无',
        picture: picture,
        tag: tags,
        video_link: video.url,
        video_description: video.desc,
        links: links,
        from: this.isBili ? 'bilibili' : '',
      }

      this.$request.post(this.$apiConfig.newPlansUrl, postData).then(res => {
        _jcq.push(['_track', 'yjhbcgenerate'])
        behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc38' })
        let resData = res.data
        if (resData.code == 0) {
          this.$router.push('/fundingnew/index')
          this.setFundingNewProjectCreate(JSON.stringify({}))
        } else {
          this.canSubmit = true
          alert('提交失败，请重新提交')
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@styles/cpunk.scss';
.page_detail_prev {
  padding-top: pxtow(130);
  .tip {
    margin-bottom: pxtow(60);
    text-align: center;
    img {
      width: pxtow(510);
    }
  }
  .part_tit {
    position: relative;
    height: pxtow(95);
    padding-left: pxtow(49);
    margin-top: pxtow(50);
    .edit {
      position: absolute;
      top: 0;
      width: pxtow(105);
      height: 100%;
    }
    &.one {
      img {
        width: pxtow(392);
      }
      .edit {
        left: pxtow(350);
      }
    }
    &.two {
      img {
        width: pxtow(397);
      }
      .edit {
        left: pxtow(359);
      }
    }
    &.three {
      img {
        width: pxtow(349);
      }
      .edit {
        left: pxtow(304);
      }
    }
  }
  .cp_list1 {
    margin-top: pxtow(20);
  }
  .banner-wrapper {
    margin-top: pxtow(20);
  }
  .video-preview {
    margin: pxtow(60) 0;
  }

  .user-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    white-space: nowrap;

    width: pxtow(652);
    height: pxtow(60);
    background: url('~@static/funding_cpunk/creation/bg_tit.png') no-repeat 0 0;
    background-size: 100% auto;
    margin: pxtow(20) auto 0;
    padding: 0 pxtow(25);
    color: #000;
    font-weight: 700;
  }

  .project-username,
  .project-userphone {
    font-size: pxtow(24);
    font-family: Arial, Helvetica, sans-serif;
  }
  .project-username .u-name,
  .project-userphone .u-phone {
    display: inline-block;
    vertical-align: middle;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    position: relative;
    padding-left: pxtow(15);
  }
  .project-username span {
    width: pxtow(140);
    overflow: hidden;
  }
  .project-userphone span {
    width: pxtow(210);
  }

  .protocol-label {
    margin-top: pxtow(50);
    margin-bottom: pxtow(20);
    text-align: center;
  }

  .protocol-label .checkbox {
    margin: 0 pxtow(12) 0 0;
    vertical-align: middle;
  }
  .protocol-label .text {
    display: inline-block;
    vertical-align: middle;
    font-size: pxtow(22);
    line-height: pxtow(32);
    letter-spacing: 0.05em;
    color: #fff;
  }

  .protocol-label .link {
    color: #98e7d4;
    border-bottom: 1px solid #98e7d4;
  }

  .checkbox {
    display: inline-block;
    position: relative;
    width: pxtow(28);
    height: pxtow(28);
    line-height: pxtow(28);
    border: pxtow(2) solid #fdff2b;
    background: transparent;
    vertical-align: middle;
    text-align: center;
  }
  .checkbox.active::after {
    content: '';
    width: pxtow(18);
    height: pxtow(18);
    background: #fdff2b;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/fundingnew/creation/Preview.vue